<template>
  <v-dialog v-model="dialog" persistent width="980px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>event</v-icon> {{id_duodecima_vacacion!=null ? 'Editar duodécimas' : 'Crear duodécimas'}}
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form
        @submit.prevent="adicionarDetalle()"
        v-model="valid"
        ref="form"
        lazy-validation
      >
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0" style="min-width: 100%;">
            <v-layout row wrap>
              <!-- @change="() => calcularDatosDuodecima()" -->
              <v-flex shrink>
                <p class="formato_green ">Seleccionar</p>
                <v-radio-group
                  class="text-field-reducido-border"
                  @change="() => (form={})" 
                  v-model="id_tipo_duodecima"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex shrink>
                    <v-radio label="Pago de vacaciones" :value="2"></v-radio>
                  </v-flex>
                  <v-flex shrink>
                    <v-radio label="Goce de vacaciones" :value="1"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                  class="text-field-reducido-border"
                  type="date"
                  v-model="fecha_fin_duodecima"
                  label="Fecha último día efectivo de trabajo"
                  @change="() => (form={})" 
                  outline
                  success
                  clearable
                />
              </v-flex>
              <v-flex shrink>
                <v-btn
                        color="rgb(134,89,166)"
                        title="Calcular duodécima"
                        dark
                        @click="calcularDatosDuodecima(true)">
                        <span class="material-symbols-outlined">
                        calculate
                        </span>   CALCULAR DUODÉCIMA
                      </v-btn>
              </v-flex>
            </v-layout>
          <v-layout row wrap v-if="switch_tipo_duodecima">
              <v-flex xs12 md6 lg6>
                <v-text-field
                  class="text-field-reducido-border"
                  v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  v-model="datos_duodecima.fecha_incorporacion"
                  label="Fecha ingreso"
                  @input="calculaDiferenciaDias()"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.fecha_inicio_calculo"
                  label="Fecha inicio para cálculo de duodécima de vacación"
                  @input="calculaDiferenciaDias()"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>

              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_trabajados_gestion"
                  label="Días trabajados en la última gestión"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_vacacion"
                  label="Días de vacación por año según el CAS"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.porcentaje_duodecima"
                  label="Porcentaje de duodécima generada"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_saldo"
                  label="Saldo de vacación a la fecha"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_duodecima"
                  label="Días de duodécima de vacación generada al último día efectivo de trabajo"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_consolidados"
                  label="Consolidado de vacaciones"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                   v-if="id_tipo_duodecima && fecha_fin_duodecima"
                  class="text-field-reducido-border"
                  v-model="datos_duodecima.dias_consolidados_total"
                  label="Consolidado de vacaciones final"
                  outline
                  success
                  clearable
                  disabled
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <p class="titulo">Detalle de saldos</p>
            </v-layout>
            <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <ul>
                  <li v-for="(detalle_gestiones, index) in detalle_gestiones_vacacion" :key="index">
                    <v-icon color="rgb(26,122,230)">{{  'folder' }}</v-icon> <b> Saldo de vacación periodo {{ parseInt(detalle_gestiones.periodo)-1 }} -  {{detalle_gestiones.periodo}} : </b> {{detalle_gestiones.saldo}}
                  </li>
                  <li>  <v-icon color="rgb(26,122,230)">{{  'folder' }}</v-icon> <b>Saldo de vacación ganada (duodécimas) al   {{fecha_fin_duodecima}} : </b>{{ datos_duodecima.dias_duodecima}}</li>
                  <li>
                    <v-icon color="rgb(26,122,230)">{{  'folder' }}</v-icon> <b>Total días de vacación : </b>{{ datos_duodecima.dias_consolidados_total}}
                  </li>
                </ul>
            </v-layout>
            <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==2 && fecha_fin_duodecima">
              <ul>
                  <li v-for="(detalle_gestiones, index) in detalle_gestiones_vacacion" :key="index">
                    <v-icon :color="detalle_gestiones.valida ? 'rgb(26,122,230)':'rgb(179,77,77)'">{{ (detalle_gestiones.valida)? 'check_circle':'close' }}</v-icon> <b> Saldo de vacación periodo {{ parseInt(detalle_gestiones.periodo)-1 }} -  {{detalle_gestiones.periodo}} : </b> {{detalle_gestiones.saldo}}
                  </li>
                  <li> <v-icon :color="datos_duodecima.duodecima_valida ? 'rgb(26,122,230)':'rgb(179,77,77)'">{{ (datos_duodecima.duodecima_valida)? 'check_circle':'close' }}</v-icon>  <b>Saldo de vacación ganada (duodécimas) al   {{fecha_fin_duodecima}} : </b>{{ datos_duodecima.dias_duodecima}}</li>
                  <li>
                    <v-icon color="rgb(26,122,230)">{{  'folder' }}</v-icon> <b>Total días de vacación : </b>{{ datos_duodecima.dias_consolidados_total}}
                  </li>
                </ul>
            </v-layout>
            
            <v-spacer></v-spacer>
            <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <p class="titulo">Registrar duodécimas adquiridas:</p>
             
            </v-layout>
            <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <v-flex xs12 md6 lg4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha desde"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                />
              </v-flex>

              <v-flex xs12 md6 lg4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha hasta"
                  @input="calculaDiferenciaDias()"
                  :rules="$validate(['required'])"
                  required
                  outline
                  success
                  clearable
                />
              </v-flex>
              <v-flex xs12 md6 lg4>
                <v-text-field
                  v-if="
                    form.fecha_desde &&
                      form.fecha_hasta"
                  v-model="total_dias"
                  label="Días"
                  disabled
                  outline
                  success
                  clearable
                />
              </v-flex>
            </v-layout>
            <v-layout v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <v-flex>
                <v-radio-group
                  @change="calculaDiferenciaDias()"
                  v-model="form.radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs4>
                    <v-radio label="Todo el día" :value="0"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo mañana" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs4>
                    <v-radio label="Solo tarde" :value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <v-flex md6>
                <v-spacer></v-spacer>
                <v-btn color="success" block type="submit" :disabled="!valid">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!--  -->
        <v-card-text >
          <v-container>
            <v-layout wrap>
              <v-flex>
                <v-data-table
                
                  :items="permiso_detalles"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        $moment(props.item.hora_desde, "HH:mm").format("HH:mm")
                      }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        $moment(props.item.hora_hasta, "HH:mm").format("HH:mm") 
                      }}
                    </td>
                    <td class="text-xs-center">
                      {{
                        props.item.dias_vacacion
                      }}
                    </td>
                    <!-- <td class="text-xs-center">
                      <v-chip
                        color="success"
                        text-color="white"
                        v-if="props.item.tipo == 0"
                        >Todo el dia</v-chip
                      >
                      <v-chip
                        color="blue"
                        text-color="white"
                        v-if="props.item.tipo == 1"
                        >Solo mañana</v-chip
                      >
                      <v-chip
                        color="orange"
                        text-color="white"
                        v-if="props.item.tipo == 2"
                        >Solo tarde</v-chip
                      >
                    </td> -->
                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar"
                        @click.prevent="eliminarDetalle(props.item.id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
                <v-layout row wrap v-if="switch_tipo_duodecima && id_tipo_duodecima && id_tipo_duodecima==1 && fecha_fin_duodecima">
              <p class="titulo">Total días programados: {{total_dias_solicitadas}}</p>
            </v-layout>
             
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="save()"
            
          >
            <v-icon>save</v-icon>
            Guardar
          </v-btn>

          <v-btn @click="close()" color="error">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import Layout from "@/common/layout/mixins/layout";
import { parse } from "json5";

export default {
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogCrearDuodecima", async dato => {
      this.form = dato;
      this.id_persona=dato.id_persona;
      this.id_tipo_duodecima=this.form.id_tipo_duodecima ? this.form.id_tipo_duodecima:null
      this.fecha_fin_duodecima=this.form.fecha_ultimo_dia;
      this.id_duodecima_vacacion=this.form.id_duodecima_vacacion
      if (this.id_tipo_duodecima && this.fecha_fin_duodecima) {
        await this.calcularDatosDuodecima(true)
        await this.construyelListaDetallesDuodecima()
      }
      this.dialog = true;
    });

    this.getRuta();
  },
  data() {
    return {
      id_duodecima_vacacion:null,
      bandera_nuevo:false,
      fecha_fin_duodecima:null,
      id_persona:null,
      detalle_gestiones_vacacion:{},
      lista_detalle_gestiones:null,
      datos_duodecima:[],
      switch_tipo_duodecima: false,
      id_tipo_duodecima: null,
      form: {},
      total_dias: 0,
      id_permi: "",
      fecha_desde: "",
      fecha_hasta: "",
      radio_data: "",
      dialog: false,
      edit: true,
      dias_saldo_para_papeletas: 0,
      loading_tabla2: false,
      lista_gestiones_por_servidor: [],
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_compensacion: [],
      aux: {},
      permiso_detalle: {},
      dias_programados_por_gestion: 0,
      valid: false,
      loading: false,
      headers: [
        {
          text: "Fecha salida",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },
        {
          text: "Hora desde",
          sortable: false
        },
        {
          text: "Hora hasta",
          sortable: false
        },
        {
          text: "Nro. de días",
          sortable: false
        },
        // {
        //   text: "Tiempo",
        //   sortable: false
        // },

        {
          text: "Acción",
          sortable: false
        }
      ],
      headers_gestiones: [
        {
          text: "Periodo desde",
          align: "center",
          sortable: false
        },
        {
          text: "Periodo hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Días asignados",
          align: "center",
          sortable: false
        },
        {
          text: "Días utilizados",
          align: "center",
          sortable: false
        },

        {
          text: "Días saldo",
          align: "center",
          sortable: false
        },
        {
          text: "Estado de la gestión",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      count_id: 0,
      // variables nueva funcionalidad
      dato: {},
      tiempo_vacaciones: 0,
      v_fecha_desde: [],
      v_fecha_hasta: [],
      v_hora_desde: [],
      v_hora_hasta: [],
      total_dias_solicitadas: 0,
      total_dias_no_programados: 0
    };
  },
  methods: {
    //obtener el saldo de vacaciones
    async construyelListaDetallesDuodecima() {
      let fecha = new Date();
      let gestion = fecha.getFullYear();
      try { //permiso_detalles
        this.permiso_detalles=[];
         this.permiso_detalles=[...this.form.detalle_duodecima ];
         this.total_dias_solicitadas= this.datos_duodecima.dias_consolidados_total
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiferenciaDias() {
      try {
        let res;

        if (
          this.form.fecha_desde &&
          this.form.fecha_hasta &&
          (this.form.radio_data == 1 ||
            this.form.radio_data == 2 ||
            this.form.radio_data == 0)
        ) {
          res = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${this.form.fecha_desde}','${this.form.fecha_hasta}',${this.id_persona})"){
								respuesta
							}
							}
						`
          });
          // this.total_dias = res.runQuery.respuesta[0].fn_obtiene_dias_habiles_entre_fechas;
          let res2;
          if (this.form.radio_data == 1 || this.form.radio_data == 2) {
            res2 =
              parseInt(
                res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona
              ) / 2;
          }
          if (this.form.radio_data == 0) {
            res2 =
              res.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
          }

          this.total_dias = res2;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // Obtiene el horario de una persona
    async obtenerHorarioPersona(id_persona, id_radio_data) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
                id_persona
              )},${parseInt(id_radio_data)},'${this.form.fecha_desde}')"){
                respuesta
              }
            }
          `
        });
        if (
          respuesta.runQuery.respuesta[0]
            .fn_rango_horario_por_persona_solo_horarios != null
        ) {
          respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
            "|"
          );
          if (respuesta[0] != "0") {
            return [respuesta[0], respuesta[1]];
          } else {
            return "No";
          }
        } else {
          this.$message.warning(
            "Sin horario asignado para la fecha del permiso"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    //listado de gestiones -periodo por persona:
    async listadoPeridosPorPersona() {
      try {
        //
        this.loading_tabla2 = true;
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"SELECT ev.id AS id_estado_vacacion,ev.periodo,ev.gestion_desde,ev.gestion_hasta,ev.dias_asignados,(ev.dias_asignados - ev.dias_restantes) AS dias_utilizados,ev.dias_restantes,vmt.fecha_incorporacion,(case when to_char(vmt.fecha_incorporacion,(extract(year from now())||'-MM-DD'))::date > now() and ev.periodo >= extract(year from now())  then 'GANAR' when to_char(vmt.fecha_incorporacion,(extract(year from now())||'-MM-DD'))::date > now() and ev.periodo between extract(year from now())-2 and extract(year from now())-1 then 'VIGENTE' when to_char(vmt.fecha_incorporacion,(extract(year from now())||'-MM-DD'))::date <= now() and ev.periodo between extract(year from now())-1 and extract(year from now()) then 'VIGENTE' when to_char(vmt.fecha_incorporacion,(extract(year from now())||'-MM-DD'))::date <= now() and ev.periodo < extract(year from now())-1 then 'PERDIDA' when to_char(vmt.fecha_incorporacion,(extract(year from now())||'-MM-DD'))::date > now() and ev.periodo < extract(year from now())-2 then 'PERDIDA' else ''	end) as tipo_gestion FROM vacaciones.estado_vacacion ev join movilidad.v_movilidad_total vmt on vmt.id_persona = ev.id_persona WHERE	ev.id_persona = ${this.dato.id_persona} and ev.id_estado <>82 ORDER BY gestion_desde, gestion_hasta asc"){
                respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_gestiones_por_servidor = respuesta;
        this.loading_tabla2 = false;
        console.log("---", respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async verificaCreacionPermiso(
      fecha_desde,
      fecha_hasta,
      radio_data,
      hora_desde,
      hora_hasta,
      list_permiso_detalles
    ) {
      try {
        let respuesta = "";
        let rpta = "1";
        let vector_fecha_desde;
        let vector_fecha_hasta;
        let vector_hora_desde;
        let vector_hora_hasta;
        let bandera_vector;
        vector_fecha_desde = "{" + this.v_fecha_desde.join(",") + "}";
        vector_fecha_hasta = "{" + this.v_fecha_hasta.join(",") + "}";
        vector_hora_desde = "{" + this.v_hora_desde.join(",") + "}";
        vector_hora_hasta = "{" + this.v_hora_hasta.join(",") + "}";
        if (list_permiso_detalles.length < 1) {
          bandera_vector = 0;
        } else {
          bandera_vector = 1;
        }
        respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select vacaciones.fn_valida_fechas_duodecimas_vacacion(${this.id_persona},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}','${vector_fecha_desde}','${vector_fecha_hasta}','${vector_hora_desde}','${vector_hora_hasta}')"){
                  respuesta
                  }
                }
              `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_valida_fechas_duodecimas_vacacion;
        rpta = respuesta.split("|");
        // rpta[1] ="Registro exitoso|"
        if (rpta[0] == "3") {
          return rpta[1];
        } else if (rpta[0] == "0") {
          return "Registro exitoso|" + rpta[1];
        } else if (rpta[0] == "1") {
          return (
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            rpta[1].replace(/#/g, "<br>")
          );
        } else {
          let resp = rpta[1].split(",");
          console.log("*****",resp[0])
          return "Usted registró un detalle en fechas:" + resp[0] + " al ";
        }
      //  return "Registro exitoso|" + "23";
      } catch (error) {
        console.log(error);
      }
    },
    validarFechasFinales() {
      let validacion_fechas;
      //validando fechas:
      let bandera_fechas = true;

      if (this.form.fecha_desde && this.form.fecha_hasta) {
        if (this.form.fecha_desde.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (this.form.fecha_hasta.length > 10) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        let año1 = parseInt(this.form.fecha_desde.substring(0, 4));
        let año2 = parseInt(this.form.fecha_hasta.substring(0, 4));

        if (año1 > 2022) {
          if (año1 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año2 > 2022) {
          if (año2 > 2999) {
            this.$message.info("Año desde no valido");
            bandera_fechas = false;
            return bandera_fechas;
          }
        }
        if (año1 < 2023) {
          this.$message.info("Año desde no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
        if (año2 < 2023) {
          this.$message.info("Año hasta no valido");
          bandera_fechas = false;
          return bandera_fechas;
        }
      }

      return bandera_fechas;
    },
    async adicionarDetalle() {
      if (this.$refs.form.validate()) {
        try {
          if (this.validarFechasFinales() == false) {
            return;
          }

          let horario = await this.obtenerHorarioPersona(
            this.id_persona,
            this.form.radio_data
          );
          if (horario != "No") {
            let verifica_creacion_vacacion = await this.verificaCreacionPermiso(
              this.form.fecha_desde,
              this.form.fecha_hasta,
              this.form.radio_data,
              horario[0],
              horario[1],
              this.permiso_detalles
            );
            let verifica_creacion_vacacion_2 = verifica_creacion_vacacion.split(
              "|"
            );
            if (verifica_creacion_vacacion_2[0] == "Registro exitoso") {
              console.log("suma dias", verifica_creacion_vacacion_2)
              //sumar los dias y verificar que no se excedan los dias de su vacacion:
              this.total_dias_solicitadas += parseFloat(
                verifica_creacion_vacacion_2[1]
              );
              if (!this.total_dias_solicitadas) {
                this.total_dias_solicitadas = 0;
              }

              if (
                this.total_dias_solicitadas <= this.datos_duodecima.dias_consolidados_total
              ) {
                //almacenar los datos ya verificados
                const temp = {
                  fecha_desde: this.form.fecha_desde,
                  fecha_hasta: this.form.fecha_hasta,
                  tipo: this.form.radio_data,
                  hora_desde: horario[0],
                  hora_hasta: horario[1],
                  id: this.count_id++,
                  dias_vacacion: verifica_creacion_vacacion_2[1]
                };
                this.permiso_detalles.push(temp);
                this.v_fecha_desde.push(this.form.fecha_desde);
                this.v_fecha_hasta.push(this.form.fecha_hasta);
                this.v_hora_desde.push(horario[0]);
                this.v_hora_hasta.push(horario[1]);
                this.form = {};
                this.$message.success("Detalle Agregado.");
              } else {
                this.total_dias_solicitadas -= parseFloat(
                  verifica_creacion_vacacion_2[1]
                );
                this.$message.info(
                  "Excede el total de dias de su saldo de vacacion"
                );
              }
            } else {
              this.$message.info(verifica_creacion_vacacion);
            }
          } else {
            this.$message.info("Usted no tiene un horario laboral asignado");
          }
          this.form.radio_data=null;
          this.total_dias=0;
        } catch (error) {
          console.log(error);
        }
      }
    },
    eliminarDetalle(id) {//total_dias_solicitadas
      let tempList = this.permiso_detalles;
      for (let i = 0; i <= tempList.length; i++) {
        if (tempList[i].id === id) {
          this.total_dias_solicitadas -= parseFloat(tempList[i].dias_vacacion);
          tempList.splice(i, 1);
          this.v_fecha_desde.splice(i, 1);
          this.v_fecha_hasta.splice(i, 1);
          this.v_hora_desde.splice(i, 1);
          this.v_hora_hasta.splice(i, 1);
          break;
        }
      }
      this.permiso_detalles = tempList;
      this.valid = true;
      this.$message.success("Detalle Eliminado");
    },
    close() {
      this.form = {};
      this.total_dias_solicitadas = 0;
      this.dialog = false;
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.permiso_detalles = [];
      this.count_id = 0;
      this.edit = true;
      this.$bus.$emit("closeDialogCrearDuodecima");
    },

    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async calcularDatosDuodecima(dato_nuevo){
      try {
        if (dato_nuevo) {
          this.permiso_detalles=[] 
        }
        this.datos_duodecima={}
      
        if (!this.fecha_fin_duodecima || !this.id_tipo_duodecima) {
          this.$message.info("Ingrese los datos solicitados");
          return;
        }
        this.switch_tipo_duodecima=false;
        let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select * from vacaciones.fn_calcula_duodecimas(${parseInt(this.id_persona)},'${this.fecha_fin_duodecima}',${this.id_tipo_duodecima})"){
                respuesta
                }
              }
            `
            })
             respuesta =
              respuesta.runQuery.respuesta[0];
              this.detalle_gestiones_vacacion=JSON.parse(respuesta.detalle_saldo);

              this.datos_duodecima=respuesta
              this.switch_tipo_duodecima=true;
              if (dato_nuevo) {
                this.total_dias_solicitadas=0
        }
      } catch (error) {
        console.log(error)
      }
    },
    async save() {
       //calcular total dias de duodecima:  datos_duodecima.dias_consolidados_total
       await this.calcularDatosDuodecima(false)

let total_dias_programados=0
this.permiso_detalles.forEach(element => {
  total_dias_programados=total_dias_programados+element.dias_vacacion;
});
if ((total_dias_programados.toString()).charAt(0)=='0') { //total_dias_solicitadas
  total_dias_programados=(total_dias_programados.toString()).slice(1)
       }
       this.total_dias_solicitadas=total_dias_programados;
if (this.id_tipo_duodecima== 1 && this.permiso_detalles.length==0) { 
        this.$message.info(`Debe programar el total de los '${this.datos_duodecima.dias_consolidados_total}' días`);
        return; 
      }
      if ((this.id_tipo_duodecima== 1 || this.id_tipo_duodecima==null || this.id_tipo_duodecima==undefined) && this.total_dias_solicitadas != this.datos_duodecima.dias_consolidados_total) {
        this.$message.info(`Debe programar el total de los '${this.datos_duodecima.dias_consolidados_total}' días`);
        return; 
      }
      let respuesta;
      let user = this.$storage.get("user");
      let bandera_exito = false;
      let error_texto = "-1";
//verificamos que se haya calculado los datos de la duodecima: calcularDatosDuodecima()

      let id_duodecima=  this.id_duodecima_vacacion!=null ? this.id_duodecima_vacacion:null
      //contruimos el json de detalle de vacaciones: Reemplazamos "" (del json) por  \" para que reconozca el graphql :ejm. "fecha_desde"  \"fecha_desde\"
      const detalle_duodecima = JSON.stringify(this.permiso_detalles).replace(/"/g,'\\"');
      try {
        respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select vacaciones.fn_crear_editar_duodecimas(${id_duodecima},${this.id_persona},'${this.fecha_fin_duodecima}'::date,${this.id_tipo_duodecima},'${detalle_duodecima}'::jsonb,${user.id})"){
                respuesta
                }
              }
            `
          });
          respuesta =respuesta.runQuery.respuesta[0].fn_crear_editar_duodecimas;
          if (respuesta) {
            bandera_exito = true;
          }
        if (bandera_exito == true) {
          this.close();
        } else {
          this.$message.error(error_texto);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.tituloForm {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.formato_green {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.sinMargen {
  display: block !important;
  padding: 0em 0em 0em 0em !important;
  margin: 0em 0em 0em 0em !important;
  width: 100% !important;
  border-radius: 0 !important;
  line-height: 1 !important;
  min-width: 100%;
}
.tabla-gestiones {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/CrearDuodecima.vue